// extracted by mini-css-extract-plugin
export default {"item":"informacaoBasica_item__g3k5s","titulo":"informacaoBasica_titulo__T4kug","conteudo":"informacaoBasica_conteudo__lphRH","item-large":"informacaoBasica_item-large__a3+q+"};